import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import TransferNote from "@/modules/transfer-notes/TransferNote";

let routes = [
  {
    path: 'transfer-notes',
    name: 'transferNotes',
    component: TransferNote,
    meta: {
      requiresAuth: true
    }
  },
];


export default {
  menuItem: new MenuItem('/transfer-notes', i18n.t('Transfer Notes'), 81, 'exchange-alt', [], 'view_transfernote'),
  routes: routes
}
